import { render, staticRenderFns } from "./medicalReportList.vue?vue&type=template&id=23f8c58c&scoped=true"
import script from "./medicalReportList.vue?vue&type=script&lang=js"
export * from "./medicalReportList.vue?vue&type=script&lang=js"
import style0 from "./medicalReportList.vue?vue&type=style&index=0&id=23f8c58c&prod&lang=scss&scoped=true"
import style1 from "./medicalReportList.vue?vue&type=style&index=1&id=23f8c58c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f8c58c",
  null
  
)

export default component.exports